import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import useLocalStorage from 'use-local-storage';
import Footer from './Navigation/Footer';
import Header from './Navigation/Header';
import LeftNavigation from './Navigation/LeftNavigation';
import { useNotificationCount } from '../hooks/useNotificationCount';
import { useMessageCount } from '../hooks/useMessageCount';

const LeftSidebar = () => {
    const [isDark, setIsDark] = useLocalStorage('isDark', false);

    useEffect(() => {
        document.body.style.removeProperty("background-color");
    }, [isDark]);
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen((prevState) => !prevState);
        console.log("Menu is toggling...");
    };
    const [showModal, setShowModal] = useState(false);
    const openModal = () => {
        setShowModal(true)
        console.log("Menu is toggling...");
    };

    const { notifiCount, setNotifiCount, NotificationCount } = useNotificationCount();
    const { msgCount, setMsgCount, MessagesCount } = useMessageCount();

    return (
        <div className='app'>
            <Header
                isDark={isDark}
                setIsDark={setIsDark}
                notifiCount={notifiCount}
                setNotifiCount={setNotifiCount}
                NotificationCount={NotificationCount}
                msgCount={msgCount}
                setMsgCount={setMsgCount}
                MessagesCount={MessagesCount}
            />
            <div className="container-fluid ps-lg-0">
                <div className="row rootLayout desktopView">
                    <div className="col-md-3 left">
                        <LeftNavigation isOpen={isOpen} toggleMenu={toggleMenu} setIsOpen={setIsOpen}
                            openModal={openModal}
                        />
                    </div>
                    <div className="col-md-9 leftSidebarData">
                        <Outlet />
                    </div>
                </div>
                <div className="row rootLayout mobileView">
                    <div className="col-md-12 ">
                        <Outlet />
                        <Footer />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LeftSidebar;
